module.exports = __webpack_public_path__ + "156e94f04296e0e9626d3fe4a9fc8a99.png";